const styles = {
  fileInput: {
    width: '732px',
    height: '200px',
  },
};

export default styles;
